import React from 'react';
import { PhoneIcon, MessageCircleIcon, SparklesIcon } from 'lucide-react';
import { contact } from '../../data/site';
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wide transition-[transform,box-shadow,background-color] duration-200 ease-smooth focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black';
export function ConsultButton({
  label = 'Consulta',
  className = ''
}: {
  label?: string;
  className?: string;
}) {
  return <a href={contact.whatsappHref} className={`${base} bg-brand-blue px-8 py-3.5 text-base text-white hover:scale-105 hover:bg-[#2a4cf0] hover:shadow-blueGlow ${className}`} data-id="element-130" data-mp="2y0hzr9u8i3va">
      <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-131" data-mp="2p1mrztbjklpv" />
      {label}
    </a>;
}
export function CallButton({
  className = ''
}: {
  className?: string;
}) {
  return <a href={contact.phoneHref} className={`${base} bg-brand-blue px-6 py-3 text-sm text-white hover:scale-105 hover:bg-[#2a4cf0] hover:shadow-blueGlow ${className}`} data-id="element-132" data-mp="1dly8jbxhy4tt">
      <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="3abqs6vi1vpax" />
      LLAMAR
    </a>;
}
export function WhatsAppButton({
  className = ''
}: {
  className?: string;
}) {
  return <a href={contact.whatsappHref} className={`${base} bg-brand-wa px-6 py-3 text-sm text-black hover:scale-105 hover:bg-[#2ee275] hover:shadow-waGlow ${className}`} data-id="element-134" data-mp="31akaij3o08g3">
      <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="2mk3ddby2c4p0" />
      WHATSAPP
    </a>;
}

/**
 * Compact phone + WhatsApp links used beside the section CTAs.
 */
export function ContactInline({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  const color = tone === 'light' ? 'text-white/85 hover:text-white' : 'text-white/70 hover:text-white';
  return <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 sm:justify-start" data-id="element-136" data-mp="23ntwyhzov21u">
      <a href={contact.phoneHref} className={`inline-flex items-center gap-2 text-sm font-medium transition-colors duration-200 ease-smooth ${color}`} data-id="element-137" data-mp="28ldh1yj2i91p">
        <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="9eetda5r0yxx" />
        {contact.phone}
      </a>
      <a href={contact.whatsappHref} className={`inline-flex items-center gap-2 text-sm font-medium transition-colors duration-200 ease-smooth ${color}`} data-id="element-139" data-mp="5eedrm6wyhpa">
        <MessageCircleIcon className="h-4 w-4 text-brand-wa" aria-hidden="true" data-id="element-140" data-mp="x52dctsxvf0u" />
        WhatsApp
      </a>
    </div>;
}